import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ProfessionalBio from './components/ProfessionalBio';
import WorkExperience from './components/WorkExperience';
import EducationCertifications from './components/EducationCertifications';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import DownloadResume from './components/DownloadResume';

const AboutExperience = () => {
  return (
    <>
      <Helmet>
        <title>About & Experience - Bello Fawas | Senior Full-Stack Developer</title>
        <meta 
          name="description" 
          content="Learn about Bello Fawas's 8+ years of full-stack development experience, education, certifications, and professional achievements. Download resume and view client testimonials." 
        />
        <meta name="keywords" content="full-stack developer, React developer, Node.js, experience, resume, testimonials, education, certifications" />
        <meta property="og:title" content="About & Experience - Bello Fawas | Senior Full-Stack Developer" />
        <meta property="og:description" content="Discover Bello Fawas's professional journey, technical expertise, and career achievements in full-stack development." />
        <meta property="og:type" content="profile" />
        <link rel="canonical" href="/about-experience" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-0">
          {/* Professional Bio Section */}
          <ProfessionalBio />
          
          {/* Work Experience Timeline */}
          <WorkExperience />
          
          {/* Education & Certifications */}
          <EducationCertifications />
          
          {/* Client Testimonials */}
          <TestimonialsCarousel />
          
          {/* Download Resume */}
          <DownloadResume />
        </main>

        {/* Footer */}
        <footer className="bg-foreground text-primary-foreground py-12">
          <div className="max-w-6xl mx-auto px-6 lg:px-8">
            <div className="text-center">
              <h3 className="text-2xl font-semibold mb-4">
                Ready to Work Together?
              </h3>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto">
                Let's discuss how my experience and skills can contribute to your next project
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/contact-form"
                  className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
                >
                  Get In Touch
                </a>
                <a
                  href="/portfolio-projects"
                  className="inline-flex items-center justify-center px-6 py-3 border border-primary-foreground/20 text-primary-foreground rounded-lg font-medium hover:bg-primary-foreground/10 transition-colors"
                >
                  View Portfolio
                </a>
              </div>
            </div>
            
            <div className="mt-12 pt-8 border-t border-primary-foreground/20 text-center">
              <p className="opacity-70">
                © {new Date()?.getFullYear()} Bello Fawas. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AboutExperience;